<form>
  <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="8px">
    <mat-form-field id="workout-name-field" fxFlex="20">
      <input
        type="text"
        placeholder="Workout Name"
        matInput
        ngDefaultControl
        [formControl]="workoutName"
      />
    </mat-form-field>
    <mat-form-field id="est-completion-field" fxFlex="20">
      <input
        type="number"
        required
        minlength="4"
        matInput
        placeholder="Estimated Completion Time (minutes)"
        [formControl]="workoutCompletionTime"
        matTooltip="Provide an estimate for how long this should take for your average trainee."
      />
      <mat-error
        *ngIf="
          workoutCompletionTime &&
          workoutCompletionTime.errors &&
          workoutCompletionTime.errors.restrictIntegers
        "
        >Please provide a whole number</mat-error
      >
      <mat-error
        *ngIf="
          workoutCompletionTime &&
          workoutCompletionTime.errors &&
          workoutCompletionTime.errors.min
        "
        >Please provide a positive number</mat-error
      >
      <mat-error
        *ngIf="
          workoutCompletionTime &&
          workoutCompletionTime.errors &&
          workoutCompletionTime.errors.required
        "
        >Estimated completion time is required</mat-error
      >
    </mat-form-field>
    <mat-form-field id="est-rpe-field" fxFlex="20">
      <mat-label>Estimated RPE</mat-label>
      <mat-select
        required
        [formControl]="workoutEstimatedRPE"
        matTooltip="Provide an estimate for how hard this should be for your average trainee."
      >
        <mat-option [value]="-1">---- No Selection ----</mat-option>
        <mat-option *ngFor="let rpe of rpeOptions" [value]="rpe.value">
          {{ rpe.value }} - {{ rpe.description }}
        </mat-option>
      </mat-select>
      <mat-error
        *ngIf="
          workoutCompletionTime &&
          workoutCompletionTime.errors &&
          workoutCompletionTime.errors.required
        "
        >Estimated completion time is required</mat-error
      >
    </mat-form-field>
  </div>
</form>
<div fxLayout="row" fxLayoutGap="16px" *ngIf="workout && workout.tiers">
  <document-tier-stairs
    id="workout-tiers"
    fxFlex="20"
    [canEdit]="canEdit"
    [canMoveTiers]="canMoveTiers"
    [tiers]="workout.tiers"
    [selectedTier]="selectedTier"
    [workoutType]="workoutType"
    [tierTemplate]="selectedTierTemplate"
    (tiersUpdated)="updateTiers($event)"
    (tierSelected)="selectTier($event)"
    (addedTierFromLibrary)="addTierFromLibrary($event)"
  ></document-tier-stairs>
  <document-tier-planning
    *ngIf="selectedTier"
    fxFlex
    [canEdit]="canEdit"
    [canMoveExercises]="canMoveTiers"
    [tier]="selectedTier"
    [exercises]="exercises"
    [exerciseCategories]="exerciseCategories"
    [tierMetadata]="selectedTierMetadata"
    [tierTemplate]="selectedTierTemplate"
    [planMetadata]="planMetadata"
    (tierUpdated)="updateTier($event)"
    (nextTier)="nextTier()"
    (previousTier)="previousTier()"
    (tierDeleted)="deleteTier($event)"
    (completed)="viewSwitched.emit()"
    (addedTierToLibrary)="addTierToLibrary($event)"
  ></document-tier-planning>
</div>
